<template>
	<el-card>
		<el-form ref="form" :model="form">
			<el-form-item label="APPID:">
				<el-input v-model="form.config_value.appid"></el-input>
			</el-form-item>
			<el-form-item label="微信支付的商户号（mch_id）:">
				<el-input v-model="form.config_value.mch_id"></el-input>
			</el-form-item>
			<el-form-item label="API密匙（key）:">
				<el-input v-model="form.config_value.key"></el-input>
			</el-form-item>
		</el-form>
		<el-button type="primary" @click="onSubmit">提交</el-button>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					name:"wxpay",
					config_value:{
						appid: '',
						mch_id: '',
						key: ''
					}
				},
			}
		},
		created() {
			this.getSysInfo();
		},
		methods: {
			onSubmit() {
				this.$H.post("common/setConfig", this.form).then(res => {
					if (res.code == 200) {
						this.$message.success("保存成功");
					}
				})
			},
			getSysInfo() {
				this.$H.get("common/getConfig",{
					name:"wxpay"
				}).then(res => {
					this.form.config_value = res.result.config_value;
				})
			}
		}
	}
</script>

<style>
</style>
